import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function FlawlessIllustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3934" data-mp="2mw2ueau7csyp">
      
      <div className="relative w-full h-full bg-gradient-to-b from-sky-200 to-indigo-300 overflow-hidden" data-id="element-3935" data-mp="2hyudedksiuz1">
        {/* Background: Sparkle field */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3936" data-mp="28wbaxukx2kdb">
          
          <circle cx="100" cy="95" r="72" fill="#E0E7FF" opacity="0.5" data-id="element-3937" data-mp="23zb77qbjhtpd" />
          <path d="M45 55 L48 64 L57 67 L48 70 L45 79 L42 70 L33 67 L42 64 Z" fill="#FFFFFF" data-id="element-3938" data-mp="74ez0juu78i0" />
          
          <path d="M158 70 L160 76 L166 78 L160 80 L158 86 L156 80 L150 78 L156 76 Z" fill="#FFFFFF" data-id="element-3939" data-mp="27ola36i8ozr" />
          
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[8%]" data-id="element-3940" data-mp="38n19kkbe0xz5">
          <div className="w-[64%] h-[64%] flex items-center justify-center" data-id="element-3941" data-mp="38koi9gjqpb9f">
            <DjaySpecimen look={{
            variant
          }} size="hero" emotion={isUnlocked ? 'celebrating' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3942" data-mp="2up2wrjcpt9lr" />
            
          </div>
        </div>

        {/* Foreground: 10 perfect marks + big sparkle */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3943" data-mp="3sa78ifs4ypfk">
          
            <path d="M100 24 L104 40 L120 44 L104 48 L100 64 L96 48 L80 44 L96 40 Z" fill="#FDE047" stroke="#CA8A04" strokeWidth="1" data-id="element-3944" data-mp="3ik5mrun99j3t" />
          
            <path d="M-10 155 Q100 178 210 155 L210 200 L-10 200 Z" fill="#4338CA" opacity="0.8" data-id="element-3945" data-mp="a3awrfrk3t75" />
          
            <text x="100" y="186" textAnchor="middle" fontFamily="sans-serif" fontSize="18" fontWeight="900" fill="white" data-id="element-3946" data-mp="os2qyexwonol">
            
              10 perfect
            </text>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}